import Vue from "vue";
import Router from "vue-router";
import BaseApi from "../api/lib/baseApi";
import Store from "../store";
import Layout from "./layout";
import MyTask from "./myTask";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: "myTask",
    },
    {
      path: "/login",
      name: "login",
      meta: { title: "用户登录" },
      component: resolve => require(["@/views/login/login"], resolve),
    },
    {
      path: "/report/viewReport/:reportId",
      name: "report_viewReport",
      meta: {
        title: "查看报告",
        pageId: "viewReport",
        pageName: "查看报告",
        parentId: "view",
        parentName: "其它功能",
        pageLayer: 2,
      },
      component: resolve => require(["@/views/report/viewReport"], resolve),
    },
    {
      path: "/view/viewAudio/:reportId/:historyReportId?",
      name: "view_viewAudio",
      meta: {
        title: "报告录音",
        pageId: "viewAudio",
        pageName: "报告录音",
        parentId: "view",
        parentName: "其它功能",
        pageLayer: 2,
      },
      component: resolve => require(["@/views/report/viewAudio"], resolve),
    },
    {
      path: "/view/reportCompare",
      name: "view_reportCompare",
      meta: {
        title: "报告比对",
        pageId: "reportCompare",
        pageName: "报告比对",
        parentId: "view",
        parentName: "其它功能",
        pageLayer: 2,
      },
      component: resolve => require(["@/views/report/reportCompare"], resolve),
    },
    {
      path: "/layout",
      name: "layout",
      meta: { title: "主框架" },
      component: resolve => require(["@/views/login/layout"], resolve),
      children: [...Layout, ...MyTask],
    },
  ],
});

router.beforeEach((to, from, next) => {
  let baseApi = new BaseApi();
  // 判断路由是否匹配，不匹配则跳转到首页
  if (to.matched.length === 0) {
    next({
      path: "/",
    });
    return;
  }
  // 判断要去的路由界面是不是要鉴权
  if (to.meta.checkLogin && !baseApi.getCookie("ops_c_token")) {
    Store.commit("Set_Head_Action", "");
    Store.commit("Set_Head_Action", "");
    next({
      path: "/login",
    });
    return;
  }
  let path = to.name.split("_");
  Store.commit("Set_Head_Action", path[0] ? path[0] : "");
  Store.commit("Set_Left_Action", path[1] ? path[1] : "");
  //来自于哪个页面
  router["referrer"] = from;
  next();
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});

router.onError(error => {
  const pattern = /Loading chunk chunk-([0-9a-zA-Z])+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    //如果出现载入失败，则进行版本校验，然后给出提示
    (async () => {
      location.reload();
    })();
  }
});

export default router;
